export const calculateOrderPoints = ({
  totalSum,
  multiplier,
}: {
  totalSum: number;
  multiplier: number;
}) => {
  return Math.round(totalSum * multiplier);
};
